import React from "react";
import { withRouter } from "react-router";
import { view } from "react-easy-state";
import { isMobile } from "react-device-detect";
import { Icon, Button } from "antd";

import AskDoubt from "components/pages/students/AskDoubt";

import VideoView from "components/pages/students/videos/show/VideoView";

import globalStore from "store/index";

class VideoDetails extends React.Component {
  goBack = () => {
    const { chapterId } = this.props.match.params;
    this.props.history.push(`/chapters/${chapterId}`);
  };

  toggleVideoList = () => {
    const videoListSider = document.getElementById("videoListSider");
    videoListSider.classList.toggle("active");
  };

  goToSettingsPage = () => {
    this.props.history.push("/settings");
  };

  goToPreviousVideo = (videoId) => {
    const { chapterId } = this.props.match.params;

    const { video, all_videos } = globalStore.ui.students.videos.show;

    const allVideosIds = all_videos.map((v) => v.id);

    const indexOfCurrentVideo = allVideosIds.indexOf(video.id);

    if (indexOfCurrentVideo > 0 && indexOfCurrentVideo < allVideosIds.length) {
      const previousVideoId = allVideosIds[indexOfCurrentVideo - 1];
      this.props.history.push(
        `/chapters/${chapterId}/videos/${previousVideoId}`
      );
    }
  };

  goToNextVideo = (videoId) => {
    const { chapterId } = this.props.match.params;

    const { video, all_videos } = globalStore.ui.students.videos.show;

    const allVideosIds = all_videos.map((v) => v.id);

    const indexOfCurrentVideo = allVideosIds.indexOf(video.id);

    if (
      indexOfCurrentVideo > -1 &&
      indexOfCurrentVideo < allVideosIds.length - 1
    ) {
      const nextVideoId = allVideosIds[indexOfCurrentVideo + 1];
      this.props.history.push(`/chapters/${chapterId}/videos/${nextVideoId}`);
    }
  };

  render() {
    const { video, match } = this.props;

    const mobileHeader = (
      <React.Fragment>
        <div className="left-menu">
          <Button type="link" onClick={this.goBack}>
            <Icon type="arrow-left" />
          </Button>
          <Button type="link" onClick={this.toggleVideoList}>
            <Icon type="unordered-list" />
          </Button>
          <Button type="link" onClick={this.goToSettingsPage}>
            <Icon type="setting" />
          </Button>
        </div>
        <div className="right-menu">
          <Button type="link" onClick={this.goToNextVideo}>
            <Icon type="arrow-right" />
          </Button>
        </div>
      </React.Fragment>
    );

    return (
      <div className="lecture-view">
        <div className="header">
          {isMobile ? (
            mobileHeader
          ) : (
            <div className="header-buttons">
              <div onClick={this.goToPreviousVideo}>
                <Icon type="arrow-left" onClick={this.goToPreviousVideo} />{" "}
                Previous
              </div>
              <div onClick={this.goToNextVideo}>
                Next <Icon type="arrow-right" />
              </div>
            </div>
          )}
        </div>
        <div className="lecture-content">
          <VideoView video={video} chapterId={match.params.chapterId}/>
          <AskDoubt
            videoId={video.id}
            chapterId={match.params.chapterId}
            hideSubjectInput={true}
            buttonStyle={{
              position: "initial",
              display: "flex",
              justifyContent: "flex-end",
            }}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(view(VideoDetails));
